import React from 'react'
import styles from './ObjectPreview.module.scss'
import { AvatarImage, Icon, Picture } from 'components'
import { icons } from 'assets'
import { getMainImageSrcForObj, getObjId } from 'utilities'
import { determineIfIsImage } from './utils'
import { getPictureIndications } from '../Picture'
import { Image } from 'models'

const ObjectPreview = ({
  object,
  selected = true,
  disabled,
  handleSelect = (_, __) => null
}) => {
  if (!object) return null

  const isObjImage = determineIfIsImage(object)

  const squarePicture = object.hasOwnProperty('actors') ||
    object.hasOwnProperty('brandId')

  const containerStyle = [styles.container]
  selected && containerStyle.push(styles.containerSelected)
  disabled && containerStyle.push(styles.containerDisabled)
  isObjImage && containerStyle.push(styles.containerImage)

  return (
    <div
      className={containerStyle.join(' ')}
      onClick={() => !disabled && handleSelect(getObjId(object), selected)}
    >
      {isObjImage
        ? (
          <Picture
            src={object.url}
            indications={getPictureIndications(object as Image)}
          />
        )
        : squarePicture
          ? (
            <Picture
              size={35}
              src={getMainImageSrcForObj(object)}
            />
          )
          : (
            <AvatarImage
              size={35}
              src={getMainImageSrcForObj(object)}
            />
          )
      }
      <h4>{object.name}</h4>
      <Icon
        icon={icons.checked}
        className={selected
          ? disabled
            ? styles.checkedAndDisabled
            : styles.checked
          : ''}
      />
    </div>
  )
}

export default ObjectPreview
